<template>
    <el-drawer title="首次沟通" :visible="visible" @update:visible="(v)=>$emit('update:visible',v)"
            :modal="modal" :append-to-body="true">
        <div class="body">
            <fragment v-for="(val,key) in question" :key="key">
                <h3>{{key}}:</h3>
                <div class="questionBox" v-for="(item,i) in val" :key="i">
                    <h4 class="question">{{i+1}}.{{item.question}}</h4>
                    <div class="options">答案：{{item.options}}</div>
                </div>
            </fragment>
        </div>
    </el-drawer>
</template>

<script>
import { recordDetail } from '@/api/cube-agent/company_questionnaire'
export default {
    props: {
        visible: {
            type: Boolean,
            default: () => false,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
        modal:{
            type: Boolean,
            default: () => true,
        }
    },
    data(){
        return {
            question:{}
        }
    },
    methods:{
        async getRecordDetail(){
            const {data:{data}} = await recordDetail({recordId:this.data.id});
            this.question = data;
            console.log(this.question);
        }
    },
    mounted(){
        this.getRecordDetail()
    }
}
</script>

<style lang="scss" scoped>
.body{
    padding: 0 1rem;
    h3{
        color: #409EFF;
    }
    .questionBox{
        padding: 0.5rem 0 0 0;
    }
}
</style>
